import './ImportModalOverlay.scss';
import { ReactElement } from 'react';

export const ImportModalOverlay = (): ReactElement => <div className='modal-overlay' />;
